import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from '../general-components/Button';
import styles from './EditUserPage.module.css';
import FormInput from '../general-components/FormInput';

const UserInfoForm: React.FC<{
    handleInfoChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    handleInfoSubmit: Function;
    errorMsg: any;
    defaultName: string;
    defaultEmail: string;
}> = ({
    handleInfoChange,
    handleInfoSubmit,
    errorMsg,
    defaultName,
    defaultEmail,
}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <form className={styles.userInfo}>
                <div className={styles.userDetails}>
                    <FormInput
                        defaultValue={defaultName}
                        label={t('userPage.userInfoForm.form.fullName')}
                        type="text"
                        onChange={handleInfoChange}
                        name="name"
                        errorMsg={errorMsg.name}
                    />
                    <FormInput
                        defaultValue={defaultEmail}
                        label={t('userPage.userInfoForm.form.email')}
                        type="email"
                        onChange={handleInfoChange}
                        name="email"
                        errorMsg={errorMsg.email}
                    />
                </div>
                <div className={styles.submitBtnField}>
                    <Button
                        type={ButtonType.submit}
                        onClick={handleInfoSubmit}
                        className={styles.submitBtn}
                    >
                        {t('userPage.userInfoForm.buttons.updateInformation')}
                    </Button>
                    <span className={styles.btnError}>{errorMsg.btn}</span>
                </div>
            </form>
        </React.Fragment>
    );
};

export default UserInfoForm;
